<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.0625 10.242V12.1094C2.0625 13.1881 2.93694 14.0625 4.01562 14.0625H21.9844C23.0631 14.0625 23.9375 13.1881 23.9375 12.1094V10.242C23.9375 9.49604 23.6706 8.77467 23.1852 8.20829L19.7635 4.21628C19.1698 3.52363 18.303 3.125 17.3908 3.125H8.60922C7.69696 3.125 6.83024 3.52363 6.23655 4.21628L2.81482 8.20829C2.32935 8.77467 2.0625 9.49604 2.0625 10.242ZM8.60922 4.6875C8.15309 4.6875 7.71973 4.88682 7.42288 5.23314L4.54236 8.59375H7.83941C8.88427 8.59375 9.85999 9.11594 10.4396 9.98531L10.6105 10.2417C10.9003 10.6764 11.3882 10.9375 11.9106 10.9375H14.0894C14.6118 10.9375 15.0997 10.6764 15.3895 10.2417L15.5604 9.98531C16.14 9.11594 17.1157 8.59375 18.1606 8.59375H21.4576L18.5771 5.23314C18.2803 4.88682 17.8469 4.6875 17.3908 4.6875H8.60922Z" 
                :fill="color"
            />
            <path d="M3.42969 15.625C2.67461 15.625 2.0625 16.2371 2.0625 16.9922V18.75C2.0625 20.4759 3.46161 21.875 5.1875 21.875H20.8125C22.5384 21.875 23.9375 20.4759 23.9375 18.75V16.9922C23.9375 16.2371 23.3254 15.625 22.5703 15.625H18.1606C17.1157 15.625 16.14 16.1472 15.5604 17.0166L15.3895 17.273C15.0997 17.7077 14.6118 17.9688 14.0894 17.9688H11.9106C11.3882 17.9688 10.9003 17.7077 10.6105 17.273L10.4396 17.0166C9.85999 16.1472 8.88427 15.625 7.83941 15.625H3.42969Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgResources',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>